import {HttpService} from "../../../services/http/Http.service";
import {Divider, Form, message, Modal} from "antd";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import CustomSpinner from "../../../components/spinner/CustomSpinner";
import React, {useState} from "react";
import AddressForm from "./components/AddressForm";
import CommonFormFields from "./components/CommonFormFields";

interface MissedPaymentProps {
    onClose: () => void,
    simulatorId?: number | undefined,
    personId?: number | undefined,
    onStatusChange?: (() => void),
    fetchAuditTrail: () => Promise<void>,
    refreshDocuments?: (() => (void | undefined)) | undefined,
    refreshInstallments?: () => Promise<void>,
    personCF?: string | undefined,
    protocolNumber?: string,
}

export default function MissedPaymentModal({
                                               onClose,
                                               simulatorId,
                                               personId,
                                               onStatusChange,
                                               fetchAuditTrail,
                                               refreshDocuments,
                                               refreshInstallments,
                                               personCF,
                                               protocolNumber
                                           }: MissedPaymentProps) {

    const [uploading, setUploading] = useState(false);
    const [autoFillAddress, setAutoFillAddress] = useState<boolean>(false);
    const disableAddressFields = autoFillAddress;

    const missedPayment = async () => {
        setUploading(true)
        const values = await form.validateFields();
        try {

            let transmittedVia
            if (values.transmissionType === "email") {
                transmittedVia = "email: " + values.email
            } else if (values.transmissionType === "pec") {
                transmittedVia = "PEC: " + values.email
            } else
                transmittedVia = values.email

            const requestBody =
                {
                    simulatorId: simulatorId,
                    personId: personId,
                    email: transmittedVia,
                    province: values.province,
                    city: values.city,
                    cap: Number(values.cap),
                    address: values.address,
                    civic: values.houseNumber,
                    archiveNumber:protocolNumber
                }
            await HttpService.getInstanceAxios().post(`/file-ts/missedPayment`, requestBody);
            message.success("PagoPa con soluzione unica generato con successo");
            onClose();
            onStatusChange?.();
            await fetchAuditTrail()
            if (refreshDocuments) {
                refreshDocuments()
            }
            if (refreshInstallments) {
                await refreshInstallments()
            }
        } catch (error) {
            HttpErrorService.handle("Errore durante la generazione del PagoPa", error, true);
        } finally {
            setUploading(false)
        }
    };

    const [form] = Form.useForm();
    return (
        <>
            <Modal
                width={800}
                title={"Mancato pagamento"}
                open={true}
                onOk={missedPayment}
                onCancel={onClose}
            >
                <Divider>Informazioni per l'invio</Divider>
                <Form form={form}>
                    <CommonFormFields fieldsToShow={["email"]}/>
                    {personCF &&
                        <AddressForm
                            autoFillAddress={autoFillAddress}
                            setAutoFillAddress={setAutoFillAddress}
                            disableAddressFields={disableAddressFields}
                            form={form}
                            personCF={personCF}
                        />
                    }
                </Form>
            </Modal>
            <CustomSpinner
                message={"Generazione PagoPa in corso..."}
                open={uploading}
            />
        </>
    )
}